module.exports = {
    site:{
        siteName:"PIPAY",
        siteFullName:"pipay.world",
        tokenAdd: "0x469658a0772bE5c76EC734ACEb56E0C75a5d47C8"
    }
}